import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import * as validators from 'utils/validators';
import InputField from 'components/InputField';
import { connect } from 'react-redux';
import * as actions from 'modules/account';
import { injectIntl } from 'react-intl';
import ColorPickerField from 'components/ColorPickerField';
import PreviewInvoice from 'components/PreviewInvoice';
import PhotoField from 'components/PhotoField';
import CollapsablePanel from './CollapsePanel';
import Themes from './Themes';
import ConfirmForm from './ConfirmForm';
import Joyride from 'react-joyride';
import SupportWidget from '../pages/SupportWidget';
import LegacyTemplateMigrationBanner from '../components/LegacyTemplateMigrationBanner';
class ProfileForm extends ConfirmForm {

    componentDidMount() {
        if (typeof window !== "undefined") {
           
            SupportWidget();

            let windowEl = (function () {
                var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                function scroll() {
                    return { left: scrollLeft, top: scrollTop };
                };
                function scrollLeft() {
                    return window.scrollX || window.pageXOffset || (isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft);
                };
                function scrollTop() {
                    return window.scrollY || window.pageYOffset || (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
                };
                return {
                    scroll: scroll,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                }
            })();

            let handle = setInterval(() => {
                let scrollY = windowEl.scrollTop();
                if (scrollY !== 0)
                    window && window.scrollTo(0, 0);
                else clearInterval(handle);

            }, 800);
        }
    }

    render() {
        let { initialValues, pristine, submitting, handleSubmit, onSubmit, intl, dispatch, accounting, taxes, hasMultipleLocations, locations, profile, themes, currentInvoiceDate } = this.props;
        const t = (id) => intl.formatMessage({ id });

        initialValues.styles = initialValues.styles || {};

        let disabled = pristine || submitting || initialValues.reverting;
        let hasChanges = !disabled;
        let isOldUser = !initialValues.dateCreated;

        return (<div>
            <style>{`
      
            textarea{
                font-size:10px;
                font-family:Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New;
                background-color: beige;
                border: none;
            }
            
            `}</style>

            <Joyride

                showProgress={true}
                continuous={true}

                floaterProps={{
                    styles: {
                        wrapper: {
                            zIndex: 9999999
                        },
                    },
                }}
                styles={{
                    options: {
                        zIndex: 9999999,
                    }
                }}

                steps={[
                    {
                        target: '#btn-template-market',
                        title: t('templates.installTranslated'),
                        content: <p>{t('templates.installTranslatedDesc')}</p>,
                        placement: 'auto',
                        event: 'auto'
                    },
                    {
                        target: '#btn-create-template',
                        title: t('templates.createNew'),
                        content: <p>{t('templates.createNewDesc')}</p>,
                        placement: 'auto',
                        event: 'auto'
                    },
                    {
                        target: '.theme-editor',
                        title: t('templates.customize'),
                        content: <p>{t('templates.customizeDesc')}</p>,
                        placement: 'auto',
                        event: 'auto'
                    }
                ]}
            >

            </Joyride>

            <form onSubmit={handleSubmit(onSubmit)}>
                {isOldUser && <CollapsablePanel location="default" section="default-template" title={t('templates.defaultTemplate')}>

                    <div className="row">
                        <div className="col-md-6">

                            <label htmlFor={`styles.logo`}>{t('templates.logo')}</label><br />
                            {profile && profile.shopify && <Field name={`styles.logo`} websiteId={`${profile.shopify.shopName}`} component={PhotoField} />
                            }<br />
                            <label>{t('templates.colorPalette')}</label>
                            <div style={{ display: 'flex' }}>
                                <Field
                                    name={`styles.colorPalette.color1`}
                                    type="text"
                                    component={ColorPickerField}
                                    label={""}
                                    color={initialValues.styles.colorPalette.color1}
                                />


                                <Field
                                    name={`styles.colorPalette.color2`}
                                    type="text"
                                    component={ColorPickerField}
                                    label={""}
                                    color={initialValues.styles.colorPalette.color2}
                                />

                                <Field
                                    name={`styles.colorPalette.color3`}
                                    type="text"
                                    component={ColorPickerField}
                                    label={""}
                                    color={initialValues.styles.colorPalette.color3}
                                />


                                <Field
                                    name={`styles.colorPalette.color4`}
                                    type="text"
                                    component={ColorPickerField}
                                    label={""}
                                    color={initialValues.styles.colorPalette.color4}
                                />

                                <Field
                                    name={`styles.colorPalette.color5`}
                                    type="text"
                                    component={ColorPickerField}
                                    label={""}
                                    color={initialValues.styles.colorPalette.color5}
                                />
                            </div>
                            <small className="pull-right"><a href="https://coolors.co/" target="_blank">{t('templates.getColorPalettes')}</a></small><br />

                            <CollapsablePanel location="default" section="printing-options" title={t('templates.paperSize')}>
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label htmlFor="styles.paperSize.format">{t('templates.format')}</label>

                                            <Field className="form-control" name="styles.paperSize.format" component="select">
                                                <option value="A3">{t('templates.a3')}</option>
                                                <option value="A4">{t('templates.a4')}</option>
                                                <option value="A5">{t('templates.a5')}</option>
                                                <option value="Legal">{t('templates.legal')}</option>
                                                <option value="Letter">{t('templates.letter')}</option>
                                                <option value="Tabloid">{t('templates.tabloid')}</option>
                                                <option value="mC-Print3">{t('templates.mcPrint3')}</option>
                                                <option value="mC-Print2">{t('templates.mcPrint2')}</option>
                                            </Field>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label htmlFor="styles.paperSize.orientation">{t('templates.orientation')}</label>

                                            <Field className="form-control" name="styles.paperSize.orientation" component="select">
                                                <option value="landscape">{t('templates.landscape')}</option>
                                                <option value="portrait">{t('templates.portrait')}</option>
                                            </Field>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label htmlFor="styles.paperSize.margin">{t('templates.margin')}</label>

                                            <Field
                                                name="styles.paperSize.margin"
                                                type="text"
                                                component={InputField}

                                                className="form-control"
                                                validate={[validators.num]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </CollapsablePanel>
                        </div>


                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-12" style={{
                                    maxWidth: '675px',
                                    width: '100%'
                                }}>
                                    <PreviewInvoice id="main" seller={profile} />
                                </div>
                            </div>
                        </div>


                    </div>



                </CollapsablePanel>}
                {
                    <FieldArray name="themes" user={initialValues} themes={themes || []} user={profile} dispatch={dispatch} component={Themes} />
                }
                <br />
                <div className={pristine ? "save-panel" : "save-panel visible"}>{t('templates.unsavedChanges')}</div>
                        {!pristine && <button type="button" onClick={() => location.reload()} className="discard-changes-button btn btn-default btn-sm">{t('templates.discard')}</button>}
                        <button id="save-changes" style={{
                            position: 'fixed',
                            top: '10px',
                            right: '10px',
                            zIndex: '99999999',
                            opacity: pristine ? 0 : 1
                }} className="btn btn-success btn-sm" type="submit" disabled={pristine || submitting || initialValues.reverting} ><i className="fa fa-check"></i>&nbsp;{t('templates.save')}</button>
                <i style={{
                    position: 'fixed',
                    top: '20px',
                    left: '13px',
                    zIndex: '99999997',
                    fontSize: '23px',
                    color: 'white'

                }} onClick={() => {
                    window.location.href = '/' + this.props.intl.locale + '/dashboard';
                }
                } className="back-button fa fa-arrow-circle-left">&nbsp;</i>
            </form>


        </div>);
    }
}


ProfileForm.PropTypes = {
    onSubmit: PropTypes.func.isRequired,
}

let ProfileFormComponent = reduxForm({ form: "Profile" })(injectIntl(ProfileForm));
ProfileFormComponent = connect(state => {
    const connectors = selector(state, 'connectors');
    const accounting = selector(state, 'accounting');
    const taxes = selector(state, 'taxes');
    const hasMultipleLocations = selector(state, 'hasMultipleLocations');
    const locations = selector(state, 'locations');
    const themes = selector(state, 'themes');

    const currentInvoiceDate = selector(state, 'currentInvoiceDate');
    return {
        connectors,
        accounting,
        currentInvoiceDate,
        hasMultipleLocations,
        locations,
        themes,
        taxes
    }
})(ProfileFormComponent)
const selector = formValueSelector('Profile');

class Profile extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let { dispatch } = this.props;

        dispatch(actions.fetchAccount());
    }

    onSubmit(account) {
        let { dispatch } = this.props;
        dispatch(actions.updateAccount(account));
    }
    render() {

        let { account, intl, profile } = this.props;
        const t = (id) => intl.formatMessage({ id });

        if (!account || !account.email) {
            return <div style={{
                position: 'absolute',
                top: '0',
                left: '50%'
            }}>{t('common.loading')}</div>
        }

        return <div className="container-fluid">
            <div className="sidebar">
                <div className="col-md-10">
                    <span style={{ marginLeft: '23px' }}>{t('templates.title')}</span>
                </div>
            </div>

            {/* Show migration banner for old users */}
            <LegacyTemplateMigrationBanner />

            <div className="row">
                <div className="col-md-12 col-lg-12 col-xs-12">

                    <ProfileFormComponent onSubmit={this.onSubmit.bind(this)} initialValues={account} profile={profile} />

                </div>
            </div>
        </div>

    }
}

Profile.propTypes = {
    account: PropTypes.object,
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        ...state.user,
        account: {
            ...state.account
        },
        profile: state.form.Profile ? state.form.Profile.values : {},
    };
}

export default injectIntl(connect(mapStateToProps)(Profile));




// WEBPACK FOOTER //
// app/containers/Templates.jsx